<template>
  <div class="menuWrap">
    <div
      class="menuIcon"
      @click="showMenu = !showMenu"
      v-click-outside="clickOutside"
    ></div>
    <ul class="menu" v-if="showMenu">
      <li
        @click="$store.commit('musicSwitch', false)"
        v-if="$store.state.music"
      >
        Music Off
      </li>
      <li @click="$store.commit('musicSwitch', true)" v-else>Music On</li>
      <!-- <li @click="showReset = true">Restart Game</li> -->
      <li>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSeCUdrzpe1QwUpTQcf2R-IbvGFMcLACvE3BLXJ3lQG-yaY4Hg/viewform?usp=sf_link"
          target="_blank"
          >Send Feedback</a
        >
      </li>

      <li class="secondary">Ver: {{ $store.state.v }}</li>
    </ul>
  </div>

  <teleport to="#app">
    <ModalReset v-if="showReset" @close="showReset = false" />
  </teleport>
</template>

<script>
import ModalReset from "@/components/ModalReset.vue";

export default {
  name: "Reset",
  components: { ModalReset },
  props: {},
  emits: [],
  data() {
    return {
      showMenu: false,
      showReset: false,
      menuOpened: false,
    };
  },

  computed: {},

  mounted: function() {},
  unmounted: function() {},

  methods: {
    clickOutside: function() {
      if (this.showMenu) {
        this.menuOpened = true;
      }

      if (this.showMenu && this.menuOpened) {
        this.showMenu = false;
        this.menuOpened = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.menuWrap {
  position: absolute;
  top: 8px;
  right: 8px;
  max-width: 16px;

  .menu {
    background: #fff;
    color: $black;
    margin: 0;
    border-radius: 6px;
    position: absolute;
    top: 20px;
    right: 0;
    padding: 8px 0;
    min-width: 160px;

    li {
      padding: 8px 16px;
      list-style: none;
      cursor: pointer;

      &:hover {
        background: $gray100;
      }

      a {
        color: $black;
        text-decoration: none;
      }
    }
  }

  .secondary {
    color: $gray800;
    font-size: 14px;
  }

  .menuIcon {
    width: 16px;
    height: 16px;
    border: 1px solid rgb(212, 196, 196);
    background: $black;
    border-radius: 6px;
    position: relative;
    opacity: 0.6;

    &:before {
      content: "";
      display: block;
      width: 4px;
      height: 4px;
      background: #fff;
      border-radius: 8px;
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
}
</style>
